import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../Components/Button/Button.js";

const COUNTDOWN = 5;

function SessionExpired() {
    const history = useHistory();
    const [seconds, setSeconds] = useState(COUNTDOWN);

    useEffect(() => {
        if (seconds <= 0) {
            history.replace("/login");
            return;
        }
        const timer = setTimeout(() => setSeconds((s) => s - 1), 1000);
        return () => clearTimeout(timer);
    }, [seconds, history]);

    const progress = ((COUNTDOWN - seconds) / COUNTDOWN) * 100;

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #fff5f3 0%, #fce8e5 100%)",
                fontFamily: "inherit",
                padding: "1rem",
            }}
        >
            <div
                style={{
                    background: "#fff",
                    borderRadius: "20px",
                    border: "1.5px solid #ece7e5",
                    boxShadow: "0 8px 40px rgba(200, 69, 53, 0.12)",
                    padding: "2.5rem 2rem",
                    maxWidth: "460px",
                    width: "100%",
                    textAlign: "center",
                }}
            >
                {/* Icon */}
                <div
                    style={{
                        width: "72px",
                        height: "72px",
                        borderRadius: "50%",
                        background: "#fff3f1",
                        border: "2px solid #f0c4be",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "2rem",
                        margin: "0 auto 1.25rem",
                    }}
                >
                    <i className="bi bi-lock" />
                </div>

                {/* Heading */}
                <h2
                    style={{
                        margin: "0 0 0.5rem",
                        fontSize: "var(--fs-display)",
                        fontWeight: 700,
                        color: "#1a1a1a",
                    }}
                >
                    Session Expired
                </h2>

                {/* Sub-text */}
                <p
                    style={{
                        margin: "0 0 1.75rem",
                        color: "#6c757d",
                        fontSize: "var(--fs-section)",
                        lineHeight: 1.5,
                    }}
                >
                    Your session has timed out for security. You will be
                    redirected to the login page in{" "}
                    <strong style={{ color: "#c84535" }}>
                        {seconds} second{seconds !== 1 ? "s" : ""}
                    </strong>
                    .
                </p>

                {/* Countdown progress bar */}
                <div
                    style={{
                        background: "#f1f5f9",
                        borderRadius: "999px",
                        height: "6px",
                        overflow: "hidden",
                        marginBottom: "1.75rem",
                    }}
                >
                    <div
                        style={{
                            height: "100%",
                            width: `${progress}%`,
                            background:
                                "linear-gradient(90deg, #c84535, #e05f4a)",
                            borderRadius: "999px",
                            transition: "width 1s linear",
                        }}
                    />
                </div>

                {/* CTA button */}
                <Button
                    variant="primary"
                    onClick={() => history.replace("/login")}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        padding: "10px 28px",
                        fontSize: "var(--fs-section)",
                        fontWeight: 600,
                        letterSpacing: "0.02em",
                    }}
                >
                    Login Now →
                </Button>
            </div>
        </div>
    );
}

export default SessionExpired;
